import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "chat-search-panel content-block" }
const _hoisted_2 = { class: "search-row flex align-items-center" }
const _hoisted_3 = { class: "search-input-container flex align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "chat-search-panel__chats-tabs"
}
const _hoisted_5 = { class: "chat-search-panel__chats-tabs-items" }
const _hoisted_6 = ["onClick"]

import {
	computed,
	ref,
	watch
} from "vue";
import { headerStore } from "@/store/header";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderChatSearchPanel',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue', 'request-focus'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit;

const store = headerStore()

const searchText = ref("");
const hoveredCloseTabId = ref<number | null>(null);

const chatsTabs = computed(() => store.getOpenedChatsHistory)
const openedChatId = computed(() => store.getOpenedChatId)
const openedChat = computed(() => store.getOpenedChat)
const isChatOpened = computed(() => !!openedChatId.value)

const getUnreadCount = (chatId: number): number =>
	store.dialogs.find(d => d.Id === chatId)?.UnreadCount ?? 0

const goBack = () => {
	searchText.value = ""
	store.setMode('list')
	store.setOpenedChat(null)
}
const onOpenDialog = async (chatId: number) => {
	if (store.getOpenedChatId !== chatId) {
		emit('request-focus')
	}
	searchText.value = "";
	store.setMode('chat')
	await store.setOpenedChat(chatId)
}


const onDeleteTab = (chatId: number) => {
	if (openedChatId.value === chatId) {
		searchText.value = ""
		store.setMode('list')
		store.setOpenedChat(null)
	}
	store.deleteOpenedChatsHistory(chatId)
}

const onCreateChat = () => {
	store.setMode('create-chat')
	store.setOpenedChat(null)
}

const onEditChat = () => {
	store.setEditedChat(openedChat.value)
	store.setMode('edit-chat')
	store.setOpenedChat(null)
}

watch(searchText, (newVal) => {
	if (newVal !== props.modelValue) {
		emit('update:modelValue', searchText.value)
	}
})

watch(() => props.modelValue, (newVal) => {
	if (newVal !== searchText.value) {
		searchText.value = newVal;
	}
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppTooltip, {
        class: "chat-search-panel__add-btn",
        text: _ctx.$t('chat_create_dialog')
      }, {
        activator: _withCtx(() => [
          _createVNode(AppIcon, {
            name: "plus",
            width: "20px",
            color: "#979797",
            "hover-color": "#499259",
            cursor: "pointer",
            onClick: onCreateChat
          })
        ]),
        _: 1
      }, 8, ["text"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AppInput, {
          modelValue: searchText.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
          class: "search-input",
          placeholder: _ctx.$t('search_short')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _createVNode(AppTooltip, {
        class: "chat-search-panel__edit-btn",
        text: _ctx.$t('chat_edit_dialog')
      }, {
        activator: _withCtx(() => [
          (
							openedChat.value
							&& !openedChat.value.IsSystem
							&& openedChat.value.CanEdit
						)
            ? (_openBlock(), _createBlock(AppIcon, {
                key: 0,
                name: "settings-outline",
                width: "18px",
                color: "#979797",
                "hover-color": "#499259",
                cursor: "pointer",
                onClick: onEditChat
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["text"])
    ]),
    (chatsTabs.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass({
					'chat-search-panel__chats-tabs-back': true,
					'chat-search-panel__chats-tabs-back--hidden': !isChatOpened.value,
				})
          }, [
            _createVNode(AppTooltip, {
              text: _ctx.$t('chat_back_to_dialogs'),
              disabled: !isChatOpened.value
            }, {
              activator: _withCtx(() => [
                _createVNode(AppIcon, {
                  class: "chat-search-panel__chats-tabs-back-btn",
                  name: "arrow-return",
                  width: "20px",
                  color: "#979797",
                  "hover-color": "#499259",
                  cursor: "pointer",
                  onClick: goBack
                })
              ]),
              _: 1
            }, 8, ["text", "disabled"])
          ], 2),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatsTabs.value, (chat) => {
              return (_openBlock(), _createBlock(AppTooltip, {
                text: _ctx.$t('chat_go_to_dialog'),
                disabled: hoveredCloseTabId.value === chat.Id,
                key: chat.Id
              }, {
                activator: _withCtx(() => [
                  (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass({
								'chat-search-panel__chats-tabs-item': true,
								'chat-search-panel__chats-tabs-item--active': openedChatId.value === chat.Id,
							}),
                    key: chat.Id,
                    onClick: ($event: any) => (onOpenDialog(chat.Id))
                  }, [
                    _createTextVNode(_toDisplayString(chat.Name) + _toDisplayString(getUnreadCount(chat.Id) > 0 ? ` (${getUnreadCount(chat.Id)})` : '') + " ", 1),
                    _createVNode(AppTooltip, {
                      text: _ctx.$t('close_label'),
                      onMouseenter: ($event: any) => (hoveredCloseTabId.value = chat.Id),
                      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hoveredCloseTabId.value = null))
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppIcon, {
                          name: "close-bold",
                          width: "12px",
                          color: openedChatId.value === chat.Id ? '#FFFFFF' : '#D2D2D2',
                          "hover-color": "#BA4C4C",
                          cursor: "pointer",
                          onClick: _withModifiers(($event: any) => (onDeleteTab(chat.Id)), ["stop"])
                        }, null, 8, ["color", "onClick"])
                      ]),
                      _: 2
                    }, 1032, ["text", "onMouseenter"])
                  ], 10, _hoisted_6))
                ]),
                _: 2
              }, 1032, ["text", "disabled"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})